class ProductScrollHandler {
  constructor() {
    this.scrollThreshold = 5; // Pixels threshold for scroll boundaries
    this.scrollMultiplier = 0.5; // Moderate scroll speed
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupScrollHandling());
    } else {
      this.setupScrollHandling();
    }
  }

  setupScrollHandling() {
    // Find the product info container and image gallery
    this.productInfoContainer = document.querySelector('.product__column-sticky');
    this.imageGallery = document.querySelector('.product__media-wrapper');
    
    if (!this.productInfoContainer || !this.imageGallery) {
      console.log('Product scroll handler: Required elements not found');
      return;
    }

    // Only add scroll redirection from image areas
    this.addImageScrollRedirection();
    this.removeScrollRestrictions();
  }

  removeScrollRestrictions() {
    // Remove any restrictive scroll behaviors
    if (this.productInfoContainer) {
      // Remove overscroll-behavior that was preventing page scroll
      this.productInfoContainer.style.overscrollBehavior = 'auto';
      // Allow natural scrolling
      this.productInfoContainer.style.scrollBehavior = 'auto';
    }
  }

  addImageScrollRedirection() {
    // Only redirect scroll from image areas to product info
    const imageContainers = [
      ...document.querySelectorAll('.gallery-thumbnails-sidebar'),
      ...document.querySelectorAll('.gallery-main-image'),
      ...document.querySelectorAll('.main-image-container'),
      ...document.querySelectorAll('.product-gallery-desktop'),
      ...document.querySelectorAll('.product-gallery-mobile')
    ];

    imageContainers.forEach(container => {
      if (container) {
        container.addEventListener('wheel', (e) => {
          this.redirectImageScroll(e);
        }, { passive: false });
      }
    });
  }

  redirectImageScroll(e) {
    const productInfo = this.productInfoContainer;
    if (!productInfo) return;

    const scrollTop = productInfo.scrollTop;
    const scrollHeight = productInfo.scrollHeight;
    const clientHeight = productInfo.clientHeight;
    const maxScroll = scrollHeight - clientHeight;

    // Only redirect if product info can scroll
    if (maxScroll > this.scrollThreshold) {
      const delta = e.deltaY;
      
      // Check if product info can scroll in the direction user is scrolling
      const canScrollDown = delta > 0 && scrollTop < maxScroll - this.scrollThreshold;
      const canScrollUp = delta < 0 && scrollTop > this.scrollThreshold;

      if (canScrollDown || canScrollUp) {
        e.preventDefault();
        
        // Scroll product info
        const scrollAmount = delta * this.scrollMultiplier;
        const newScrollTop = Math.max(0, Math.min(scrollTop + scrollAmount, maxScroll));
        productInfo.scrollTop = newScrollTop;
      }
      // If product info can't scroll further, let page scroll naturally
    }
  }
}

// Initialize when DOM is ready
if (typeof window !== 'undefined') {
  new ProductScrollHandler();
}
